<div *ngIf="(!product?.mapPresent && product?.hopOnHopOff) || (product?.hopOnHopOff && isNode)">
  <h2 class="h2" *ngIf="product?.routes && product?.routes.length>0" text-color="gray-dark">{{'ROUTES' | translate}}</h2>
  <div class="route-navigator">
      <div (click)="openMap()" class="route-name map" [ngClass]="{'active':isMapOpened}">
          {{'MAP' | translate}}
      </div>
      <div class="stops-list" [ngClass]="{'active':isMapOpened}">
          <div class="map-with-zoom ">
              <progressive-image  ></progressive-image>
              <progressive-image *ngIf="product?.hopOnImage" [bigImage]="getMapImage('LARGE')" [smallImage]="getMapImage('MICRO')"></progressive-image>                
              <a href="{{getMapImage()}}" download="" class="mapDownload">{{'DOWNLOAD' | translate}}</a>
          </div>

      </div>
      <ng-container *ngFor="let route of routes; let index=index">
          <div class="route-name" (click)="open(route)" [ngClass]="{'active':route.opened}" [ngStyle]="{'color':route.color, 'border-left-color':route.color, 'background-color': route.color, '-ms-grid-row': (index + 2)}">
              {{route.name}}
          </div>
          <div class="stops-list" [ngClass]="{'active':route.opened}">
              <div class="route-summary" [ngStyle]="{'background-color':route.color}">
                  <span>
                      <b>{{'HOURS' | translate}}:</b> {{route?.startTime}} - {{route?.endTime}}</span>
                  <span>
                      <b>{{'LOOPS' | translate}}:</b> {{route?.loop}} {{'MINUTE' | translate}}</span>
                  <span>
                      <b>{{'FREQUENCY' | translate}}:</b> {{route?.frequency}} {{'MINUTE' | translate}}</span>
              </div>
              <div class="stop-columns-container">
                  <div class="stops-colum css-hide-tablet css-hide-phone" *ngFor="let stops of splitStops(route?.stoppingPlaces)">
                      <div class="stop-row" *ngFor="let stop of stops">
                          <span class="order-node" [style.background-color]="route?.color">
                              {{stop.number}}
                          </span>
                          <span>{{stop.name}}</span>
                      </div>
                  </div>
                  <dot-navigation class="stops-colum css-hide-desktop">
                      <dot-navigation-page *ngFor="let stops of splitStops(route?.stoppingPlaces,true)">
                          <div class="stop-row" *ngFor="let stop of stops">
                              <span class="order-node" [style.background-color]="route?.color">
                                  {{stop.number}}
                              </span>
                              <span>{{stop.name}}</span>
                          </div>
                      </dot-navigation-page>
                  </dot-navigation>
              </div>
          </div>
      </ng-container>
  </div>
</div>
<div *ngIf="product?.mapPresent && product?.hopOnHopOff && !isNode">
  <h2 class="h2" *ngIf="product?.routes && product?.routes.length>0" text-color="gray-dark">{{'ROUTES' | translate}}</h2>
  <div class="map-overlay" *ngIf="!showMapButtonClicked">
    <button id="js-show-map" color="primary" class="mat-raised-button" (click)="onShowMapClick()">{{'DISPLAY_MAP' | translate}}</button> 
  </div>
  <css-map *ngIf="showMaps && showMapButtonClicked" id="hoho-map" [product-id]="product?.id" [device]="device"></css-map>
  <div *ngIf="!showMaps" class="map-overlay">
      <svg height="100px" width="100px">
          <image class="svg-img notranslate" height="100px" width="100px" xlink:href="./assets/images/loading-map.svg"/>
      </svg>
  </div>
</div>
<div class="agm" *ngIf="!isNode && !product?.hopOnHopOff && product?.meetingPoints && !hasNotMeetingPoint" [@listAnimation]="listOfPointsAux.length">
  <div class="agm__meeting">
      <div class="agm__meeting-map">
          <div class="agm__meeting-icon">
              <i class="material-icons notranslate">location_on</i>
          </div>
          <span>{{'MAP' | translate}}</span>
      </div>
      <div (click)="toggleItems()" class="agm__meeting-meetpoint">
          <div class="agm__meeting-container">
              <div class="agm__meeting-meeticon">
                  <i class="material-icons notranslate">
                      directions_walk
                  </i>
              </div>
              <span>Meeting point</span>
          </div>
          <div class="agm__meeting-arrow">
              <i [ngClass]="{'rotateIcon':animationList}" class="material-icons notranslate">keyboard_arrow_down</i>
          </div>
      </div>
      <div (click)="infoToMaps(points)" class="agm__meeting-infopoints" *ngFor="let points of listOfPointsAux">
          <span class="span_title">{{points.name}}</span>
          <span class="span_info">{{points.info}}</span>
      </div>
  </div>
  <agm-map #gm 
          [gestureHandling]="'cooperative'" 
          [scrollwheel]=null
          [zoom]="zoomMap" 
          [streetViewControl]="false" 
          [latitude]="lat" 
          [longitude]="lng" >
          <agm-marker *ngFor="let p of listOfPoints;let i = index" (markerClick)="clickedMarker(infoWindow)" 
                      [openInfoWindow]="true" 
                      [iconUrl]="icon" 
                      [latitude]="p.latitude" 
                      [longitude]="p.longitude">
              <agm-info-window [isOpen]="isInfoWindowOpen(p.id)" #infoWindow>
                  <div>{{p.name}}</div>
                  <div><a>{{p.info}}</a></div>
              </agm-info-window>
          </agm-marker>
  </agm-map>
</div>